import { useEffect, useState } from "react";
import useScript from "react-script-hook";
import Auth from "../Auth";

export default ({ subscription }) => {
  const [loading, error] = useScript({ src: "https://assets.churnkey.co/js/app.js?appId=8fpinw773" });
  const [churnkeyToken, setChurnkeyToken] = useState(null);

  useEffect(() => {
    if (subscription && subscription.data?.stripeStatus === "active") {
      Auth.fetchWithIdToken("/api/churnkey/token", {}).then((res) => {
        if (res.token) {
          setChurnkeyToken(res.token);
        }
      });
    }
  }, [subscription]);

  return [!loading && !error && !!churnkeyToken, churnkeyToken];
};
